<script>
    // ═══ НАПРАВЛЯЮЩИЕ РЕДАКТОРА ХУДА ═══
    // Рисует поверх экрана то, что помогает выровнять блоки:
    //   • линии от краёв и центра выбранного блока — через весь экран;
    //   • подсветку совпадений с краями и центрами других блоков (золотая линия);
    //   • расстояния до краёв экрана — сверху, снизу, слева, справа;
    //   • расстояние до ближайшего соседа по горизонтали и вертикали.
    // Данные считает hudbox (он знает, что тащат), здесь только отрисовка.
    import { hudGuides, hudEditMode } from 'store/hudlayout'

    $: g = $hudEditMode ? $hudGuides : null;
    const px = (v) => Math.round(v) + 'px';
</script>

{#if g}
<div class="hg">
    <!-- рамка выбранного блока -->
    <div class="hg-box" style="left:{px(g.l)};top:{px(g.t)};width:{px(g.w)};height:{px(g.h)}"></div>

    <!-- собственные линии блока: края и центр, через весь экран -->
    {#each g.selfX as x}<div class="hg-line v self" style="left:{px(x)}"></div>{/each}
    {#each g.selfY as y}<div class="hg-line h self" style="top:{px(y)}"></div>{/each}

    <!-- совпадение с другим блоком: линия горит золотом -->
    {#each g.snapX as x}<div class="hg-line v snap" style="left:{px(x)}"></div>{/each}
    {#each g.snapY as y}<div class="hg-line h snap" style="top:{px(y)}"></div>{/each}

    <!-- расстояния до краёв экрана -->
    <div class="hg-dim v" style="left:{px(g.cx)};top:0;height:{px(g.t)}">
        <span class="hg-num">{Math.round(g.t)}</span>
    </div>
    <div class="hg-dim v" style="left:{px(g.cx)};top:{px(g.b)};height:{px(g.sh - g.b)}">
        <span class="hg-num">{Math.round(g.sh - g.b)}</span>
    </div>
    <div class="hg-dim h" style="top:{px(g.cy)};left:0;width:{px(g.l)}">
        <span class="hg-num">{Math.round(g.l)}</span>
    </div>
    <div class="hg-dim h" style="top:{px(g.cy)};left:{px(g.r)};width:{px(g.sw - g.r)}">
        <span class="hg-num">{Math.round(g.sw - g.r)}</span>
    </div>

    <!-- расстояния до соседних блоков -->
    {#each g.gaps as d}
        {#if d.dir === 'h'}
            <div class="hg-gap h" style="top:{px(d.at)};left:{px(d.from)};width:{px(d.size)}">
                <span class="hg-num gap">{Math.round(d.size)}</span>
            </div>
        {:else}
            <div class="hg-gap v" style="left:{px(d.at)};top:{px(d.from)};height:{px(d.size)}">
                <span class="hg-num gap">{Math.round(d.size)}</span>
            </div>
        {/if}
    {/each}
</div>
{/if}

<style>
    .hg {
        position: fixed; inset: 0; z-index: 60; pointer-events: none;
        font-family: 'Manrope', sans-serif;
    }
    .hg-box {
        position: absolute;
        border: 1px solid rgba(231, 174, 63, 0.75);
        box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.45);
    }
    .hg-line { position: absolute; }
    .hg-line.v { top: 0; bottom: 0; width: 1px; }
    .hg-line.h { left: 0; right: 0; height: 1px; }
    /* свои линии — тихие, чтобы не рябило */
    .hg-line.self { background: repeating-linear-gradient(to bottom, rgba(255,255,255,.22) 0 6px, transparent 6px 12px); }
    .hg-line.h.self { background: repeating-linear-gradient(to right, rgba(255,255,255,.22) 0 6px, transparent 6px 12px); }
    /* совпало с другим блоком — золотая сплошная */
    .hg-line.snap { background: rgba(231, 174, 63, 0.95); box-shadow: 0 0 8px rgba(231, 174, 63, 0.55); }

    /* мерная линия до края экрана */
    .hg-dim { position: absolute; display: flex; align-items: center; justify-content: center; }
    .hg-dim.v { width: 1px; background: repeating-linear-gradient(to bottom, rgba(231,174,63,.5) 0 4px, transparent 4px 8px); }
    .hg-dim.h { height: 1px; background: repeating-linear-gradient(to right, rgba(231,174,63,.5) 0 4px, transparent 4px 8px); }

    /* мерная линия до соседнего блока */
    .hg-gap { position: absolute; display: flex; align-items: center; justify-content: center; }
    .hg-gap.v { width: 1px; background: rgba(108, 194, 138, 0.75); }
    .hg-gap.h { height: 1px; background: rgba(108, 194, 138, 0.75); }

    .hg-num {
        padding: 1px 5px; border-radius: 4px;
        background: rgba(10, 9, 7, 0.9);
        border: 1px solid rgba(231, 174, 63, 0.45);
        color: #f0c863;
        font: 700 10px 'Manrope', sans-serif;
        line-height: 14px; white-space: nowrap;
    }
    .hg-num.gap { border-color: rgba(108, 194, 138, 0.55); color: #8fd6a8; }
</style>
